var StopClickPropagationDirective = /** @class */ (function () {
    function StopClickPropagationDirective() {
    }
    StopClickPropagationDirective.prototype.onClick = function (event) {
        event.stopPropagation();
    };
    return StopClickPropagationDirective;
}());
export { StopClickPropagationDirective };
